'use client';

import dynamic from 'next/dynamic';
import Script from 'next/script';

import { useInView } from 'react-intersection-observer';

const AdSlot = dynamic(
  () => import('./components/AdSlot').then((mod) => mod.AdSlot),
  {
    ssr: false,
  }
);

interface GoogleAdProps {
  slug: string;
}

function GoogleAd(props: Readonly<GoogleAdProps>) {
  const { slug } = props;

  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '200px',
  });

  return (
    <>
      <div ref={ref} />
      {inView && (
        <>
          <Script
            id="google-publisher-tag-script"
            strategy="afterInteractive"
            async
            src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
            data-testid="google-publisher-tag-script"
          />

          <AdSlot slug={slug} />
        </>
      )}
    </>
  );
}

export default GoogleAd;
